/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon24Solid = forwardRef('NetConnectWifiIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12.003 6.5a12 12 0 0 0-8.796 3.834 1.5 1.5 0 1 1-2.199-2.041 15 15 0 0 1 21.989.006 1.5 1.5 0 1 1-2.2 2.04A12 12 0 0 0 12.003 6.5Z" }),
        React.createElement("path", { d: "M12.001 13a5.501 5.501 0 0 0-4.158 1.899 1.5 1.5 0 1 1-2.268-1.964 8.5 8.5 0 0 1 12.852.003 1.5 1.5 0 1 1-2.268 1.963A5.502 5.502 0 0 0 12.001 13Z" }),
        React.createElement("path", { d: "M12 20.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" })));
});
